import { useEffect, useState } from 'react'
import { FullScreenLoading } from '../Components/Common/loader/FullScreenLoading'
import { InvalidTokenMessage } from './components/InvalidTokenMessage'
import { COMPONENT_STATUS } from '../infra/constants/ComponentStatus'
import { ERROR_TYPES } from '../infra/constants/ErrorTypes'
import useEnsureValidToken from '../pages/OrderSupplierReception/hooks/useEnsureValidToken'

const SmartProtectedRoute = ({ children }) => {
    const { ensureValidToken } = useEnsureValidToken()
    const [status, setStatus] = useState(COMPONENT_STATUS.IDLE) // 'idle' | 'checking' | 'valid' | 'invalid'
    const [errorType, setErrorType] = useState(null)

    useEffect(() => {
        let mounted = true
        const controller = new AbortController()

        const run = async () => {
            setStatus(COMPONENT_STATUS.CHECKING)

            try {
                if (!mounted) return
                await ensureValidToken()
                setStatus(COMPONENT_STATUS.VALID)
                setErrorType(null)
            } catch (error) {
                if (!mounted) return
                setStatus(COMPONENT_STATUS.INVALID)
                setErrorType(ERROR_TYPES.INVALID)
            }
        }

        run()

        return () => {
            mounted = false
            controller.abort()
        }
    }, [ensureValidToken])

    useEffect(() => {
        if (status !== COMPONENT_STATUS.VALID) return

        const id = setInterval(async () => {
            try {
                await ensureValidToken()
            } catch (error) {
                setStatus(COMPONENT_STATUS.INVALID)
                setErrorType(ERROR_TYPES.INVALID)
            }
        }, 5 * 60 * 1000)
        return () => clearInterval(id)
    }, [status, ensureValidToken])

    if (status === COMPONENT_STATUS.CHECKING) return <FullScreenLoading />
    if (status === COMPONENT_STATUS.VALID) return <>{children}</>
    return <InvalidTokenMessage type={errorType} />
}

export default SmartProtectedRoute